import { captureSession, isSessionCurrent } from './authSession';
export const FEEDBACK_ACTION_EVENT = 'medeffects:feedback-action-completed';
let pending = null;
let cooldown = null;
export function getPendingFeedback() {
  if (pending && (!isSessionCurrent(pending.session) || Date.now() > pending.expiresAt || window.location.pathname !== pending.path)) pending = null;
  return pending;
}
export function notifyFeedbackActionCompleted() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!['clinic', 'sales_rep'].includes(user?.role) || user.isActive === false) return;
    const session = captureSession();
    if (!session.userId || !session.hadToken) return;
    if (cooldown && isSessionCurrent(cooldown.session) && Date.now() < cooldown.until) return;
    if (!getPendingFeedback()) pending = { session, operationId: crypto.randomUUID(), readyAt: Date.now() + 4000, expiresAt: Date.now() + 120000, path: window.location.pathname };
    window.dispatchEvent(new Event(FEEDBACK_ACTION_EVENT));
  } catch { /* Optional feedback must never change a completed business action's outcome. */ }
}
export function finishFeedback(entry, nextEligibleAt) {
  if (pending !== entry) return;
  pending = null;
  const until = Date.parse(nextEligibleAt);
  if (Number.isFinite(until)) cooldown = { session: entry.session, until };
}
